export function useSeoData(seo) {
    const route = useRoute();
    const seoObj = {};

    seoObj.title = seo.title;
    seoObj.description = seo.description;

    if (seo.keywords) {
        seoObj.keywords = seo.keywords.map(item => item.keyword).join(', ');
    }

    if (seo.social) {
        if (seo.social.twitter) {
            seoObj.twitterCard = 'summary_large_image';
            seoObj.twitterSite = '';
            seoObj.twitterUrl = route.path;
            seoObj.twitterTitle = seo.social.twitter.title;
            if (seo.social.twitter.description) seoObj.twitterDescription = seo.social.twitter.description;
            if (seo.social.twitter.image) seoObj.twitterImage = seo.social.twitter.image.webp;
        }

        if (seo.social.facebook) {
            seoObj.fbApp_id = '';
            seoObj.ogUrl = route.path;
            seoObj.ogType = 'website';
            if (seo.social.facebook.title) seoObj.ogTitle = seo.social.facebook.title;
            if (seo.social.facebook.image) {
                seoObj.ogImage = seo.social.facebook.image.webp
                seoObj.ogImageWidth = '1200';
                seoObj.ogImageHeight = '600';
            }
            if (seo.social.facebook.description) {
                seoObj.ogDescription = seo.social.facebook.description;
            }
            seoObj.ogSite_name = 'PUQ Coffee - Master your craft';
            seoObj.ogLocale = 'en';
            seoObj.ogLogo = 'https://cdn.puq.coffee/media/general/logo-puq-og.png';

        }
    }

    return seoObj;
}